module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_1-d5f533de0a60d04bd4bbc91ee8ea4069.jpg";